import { AxiosError } from "axios";
import { GetReportJobStatusRequest, GetReportJobStatusResponse } from "../daos/read/get_report_job_status";
import { axiosReportInstance } from "../../../../common/utils/axios_report_instance";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { IReportsService } from "./reports_service";
import { GetRelatorioFuncionarioTreinamentoRequest, GetRelatorioFuncionarioTreinamentoResponse } from "../daos/read/get_relatorio_funcionario_treinamento";
import { GetRelatorioCadastroFuncionarioRequest, GetRelatorioCadastroFuncionarioResponse } from "../daos/read/get_relatorio_cadastro_funcionario";
import { GetRelatorioCargosRequest } from "../daos/read/get_relatorio_cargos";
import { GetReportFuncionariosRequest, GetReportFuncionariosResponse } from "../daos/read/get_report_funcionarios";
import { GetReportTreinamentosRequest, GetReportTreinamentosResponse } from "../daos/read/get_report_treinamentos";
import { GetReportDocumentosRequest, GetReportDocumentosResponse } from "../daos/read/get_report_documentos";
import { GetReportTreinamentoFuncionarioRequest, GetReportTreinamentoFuncionarioResponse } from "../daos/read/get_report_treinamento_funcionario";
import { GetReportFolhaPagamentoRequest, GetReportFolhaPagamentoResponse } from "../daos/read/get_report_folha_pagamento";
import { GetReportFolhaPagamentoDetalhadaRequest, GetReportFolhaPagamentoDetalhadaResponse } from "../daos/read/get_report_folha_pagamento_detalhada";
import { GetRelatorioAvaliacaoHabilidadeRequest, GetRelatorioAvaliacaoHabilidadeResponse } from "../daos/read/get_relatorio_avaliacao_habilidade";
import { GetReportMapaConcretagemRequest, GetReportMapaConcretagemResponse } from "../daos/read/get_report_mapa_concretagem";
import { GetReportPlanoQualidadeObraRequest, GetReportPlanoQualidadeObraResponse } from "../daos/read/get_report_plano_qualidade_obra";
import { GetReportControleSustentabilidadeRequest, GetReportControleSustentabilidadeResponse } from "../daos/read/get_report_controle_sustentabilidade";
import { GetReportMonitoramentoChecklistRequest, GetReportMonitoramentoChecklistResponse } from "../daos/read/get_report_monitoramento_checklist";
import { GetReportObraChecklistRequest, GetReportObraChecklistResponse } from "../daos/read/get_report_obra_checklist";
import { GetReportChecklistAreaRequest, GetReportChecklistAreaResponse } from "../daos/read/get_report_checklist_area";
import { GetReportPlanoAuditoriaRequest, GetReportPlanoAuditoriaResponse } from "../daos/read/get_report_plano_auditoria";
import { GetReportAcoesPreventivasRequest, GetReportAcoesPreventivasResponse } from "../daos/read/get_report_acoes_preventivas";
import { GetReportAcoesCorretivasRequest, GetReportAcoesCorretivasResponse } from "../daos/read/get_report_acoes_corretivas";
import { GetReportListaChecklistServicoRequest, GetReportListaChecklistServicoResponse } from "../daos/read/get_lista_checklist_servico";
import { GetReportListaChecklistServicoItemRequest, GetReportListaChecklistServicoItemResponse } from "../daos/read/get_report_lista_checklist_servico_item";
import { GetReportListaFornecedorRequest, GetReportListaFornecedorResponse } from "../daos/read/get_report_lista_fornecedor";
import { GetReportContaPagarRequest, GetReportResponse } from "../daos/read/get_report_conta_pagar";
import { GetReportContaReceberRequest, GetReportContaReceberResponse } from "../daos/read/get_report_conta_receber";
import { GetReportContasPagarAnaliticoRequest, GetReportContasPagarAnaliticoResponse } from "../daos/read/get_report_contas_pagar_analitico";
import { GetReportContasReceberAnaliticoRequest, GetReportContasReceberAnaliticoResponse } from "../daos/read/get_report _contas_receber_analitico";
import { GetReportContratoFinanceiroListaRequest, GetReportContratoFinanceiroListaResponse } from "../daos/read/get_report_contrato_financeiro_lista";
import { GetReportContratoFinanceiroIndividualRequest, GetReportContratoFinanceiroIndividualResponse } from "../daos/read/get_report_contrato_financeiro_individual";
import { GetReportSaldoBancarioRequest, GetReportSaldoBancarioResponse } from "../daos/read/get_report_saldo_bancario";
import { GetReportRateioGeralRequest, GetReportRateioGeralResponse } from "../daos/read/get_report_rateio_geral";
import { GetReportServicoProdutoRequest, GetReportServicoProdutoResponse } from "../daos/read/get_report_servico_produto";
import { GetReportRequisicaoCompraRequest, GetReportRequisicaoCompraResponse } from "../daos/read/get_report_requisicao_compra";
import { GetReportColetaPrecoRequest, GetReportColetaPrecoResponse } from "../daos/read/get_report_coleta_preco";
import { GetReportOrdemCompraRequest, GetReportOrdemCompraResponse } from "../daos/read/get_report_ordem_compra";
import { GetReportOrdemComprasRequest, GetReportOrdemComprasResponse } from "../daos/read/get_report_ordem_compras";
import { GetReportOrdemComprasLoteRequest, GetReportOrdemComprasLoteResponse } from "../daos/read/get_report_ordem_compras_lote";
import { GetReportNovosNegociosListaRequest, GetReportNovosNegociosListaResponse } from "../daos/read/get_report_novos_negocios_lista";
import { GetReportNovosNegociosRequest, GetReportNovosNegociosResponse } from "../daos/read/get_report_novos_negocios";
import { GetReportPermissaoAcessoRequest, GetReportPermissaoAcessoResponse } from "../daos/read/get_relatorio_permissao_acesso";
import { GetReportLogAcessoSistemaRequest, GetReportLogAcessoSistemaResponse } from "../daos/read/get_relatorio_log_acesso_sistema";
import { GetReportGedInternoRequest, GetReportGedInternoResponse } from "../daos/read/get_report_ged_interno";
import { GetReportGedExternoRequest, GetReportGedExternoResponse } from "../daos/read/get_report_ged_externo";
import { GetReportSatisfacaoClientePesquisaRequest, GetReportSatisfacaoClientePesquisaResponse } from "../daos/read/get_report_satisfacao_cliente_pesquisa";
import { GetReportDiarioObraIndividualRequest, GetReportDiarioObraIndividualResponse } from "../daos/read/get_report_diario_obra_individual_pesquisa";
import { GetReportListaFuncionariosTRequest, GetReportListaFuncionariosTResponse } from "../daos/read/get_report_lista_funcionarios_t_pesquisa";
import { GetReportFuncionarioTreinamentoTercRequest, GetReportFuncionarioTreinamentoTercResponse } from "../daos/read/get_report_funcionario_treinamento_terc";
import { GetReportMedicaoTerceirizacaoRequest, GetReportMedicaoTerceirizacaoResponse } from "../daos/read/get_report_medicao_terceirizacao";
import { GetReportTreinamentoFuncionarioTercRequest, GetReportTreinamentoFuncionarioTercResponse } from "../daos/read/get_report_treinamento_funcionario_terc";
import { GetReportProcessosRiscosRequest, GetReportProcessosRiscosResponse } from "../daos/read/get_report_procesos_riscos";
import { GetReportCronogramaRequest, GetReportCronogramaResponse } from "../daos/read/get_report_cronograma";
import { GetReportProvisaoRecursosRequest, GetReportProvisaoRecursosResponse } from "../daos/read/get_report_provisao_recursos";
import { GetReportEntradaProdutoRequest, GetReportEntradaProdutoResponse } from "../daos/read/get_report_entrada_produto";
import { GetReportSaidaProdutoRequest, GetReportSaidaProdutoResponse } from "../daos/read/get_report_saida_produto";
import { GetReportControleEstoqueRequest, GetReportControleEstoqueResponse } from "../daos/read/get_report_controle_estoque";
import { GetReportAssistenciaTecnicaRequest, GetReportAssistenciaTecnicaResponse } from "../daos/read/get_report_assistencia_tecnica";
import { GetReportAssistenciaTecnicaBasicoRequest, GetReportAssistenciaTecnicaBasicoResponse } from "../daos/read/get_report_assistencia_tecnica_basico";
import { GetReportAssistenciaTecnicaCompletoRequest, GetReportAssistenciaTecnicaCompletoResponse } from "../daos/read/get_report_assistencia_tecnica_completo";
import { GetReportEntregaObraClienteSimplesRequest, GetReportEntregaObraClienteSimplesResponse } from "../daos/read/get_report_entrega_obra_cliente_simples";
import { GetReportEntregaObraClienteFotograficoRequest, GetReportEntregaObraClienteFotograficoResponse } from "../daos/read/get_report_entrega_obra_cliente_fotografico";
import { GetReportEntregaObraClienteGeralRequest, GetReportEntregaObraClienteGeralResponse } from "../daos/read/get_report_entrega_obra_cliente_geral";
import { GetReportEntregaObraClienteLoteRequest, GetReportEntregaObraClienteLoteResponse } from "../daos/read/get_report_entrega_obra_cliente_lote";
import { GetReportEntregaObraClienteTermoRequest, GetReportEntregaObraClienteTermoResponse } from "../daos/read/get_report_entrega_obra_cliente_termo";
import { GetReportMaquinasEquipRequest, GetReportMaquinasEquipResponse } from "../daos/read/get_report_maquinas_equip";
import { GetReportMateriaisControladosRequest, GetReportMateriaisControladosResponse } from "../daos/read/get_report_materiais_controlados";
import { GetReportFluxoCaixaListaRequest, GetReportFluxoCaixaListaResponse } from "../daos/read/get_report_fluxo_caixa";
import { GetReportTreinamentosFuncionariosRequest, GetReportTreinamentosFuncionariosResponse } from "../daos/read/get_report_treinamentos_funcionarios";
import { GetReportListaDisciplinasRequest, GetReportListaDisciplinasResponse } from "../daos/read/get_report_lista_disciplinas";
import { GetReportObraServicosControladosRequest, GetReportObraServicosControladosResponse } from "../daos/read/get_report_obra_servicos_controlados";
import { GetReportComprasRelatorioComprasRequest, GetReportComprasRelatorioComprasResponse } from "../daos/read/get_report_compras_relatorio_compras";
import { GetReportPlanoProjetoRequest, GetReportPlanoProjetoResponse } from "../daos/read/get_report_plano_projeto";
import { GetReportIndicadoresRequest, GetReportIndicadoresResponse } from "../daos/read/get_report_indicadores";
import { GetReportChecklistEntregaListaRequest, GetReportChecklistEntregaListaResponse } from "../daos/read/get_relatorio_checklist_entrega_lista";
import { GetMonitoramentoChecklistIAResponse, GetReportFvsDinamicoRequest, GetReportFvsDinamicoResponse } from "../daos/read/get_report_fvs_dinamico";

/**
 * ReportsService
 */

export class ReportsService implements IReportsService {
  async getReportJobStatus(request: GetReportJobStatusRequest): Promise<GetReportJobStatusResponse> {
    try {
      const result = await axiosReportInstance({}).get<GetReportJobStatusResponse>(
        `/jobs/${encodeURIComponent(request.operacaoId)}`,
      );
      return handleAxiosResponse<GetReportJobStatusResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getRelatorioFuncionarioTreinamento(
    request: GetRelatorioFuncionarioTreinamentoRequest
  ): Promise<GetRelatorioFuncionarioTreinamentoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/funcionarios/treinamentos`, request);
      const response = handleAxiosResponse<GetRelatorioFuncionarioTreinamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getRelatorioAvaliacaoHabilidade(
    request: GetRelatorioAvaliacaoHabilidadeRequest,
  ): Promise<GetRelatorioAvaliacaoHabilidadeResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/funcionarios/habilidades/avaliacao`, request);
      const response = handleAxiosResponse<GetRelatorioAvaliacaoHabilidadeResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getRelatorioCadastroFuncionario(
    request: GetRelatorioCadastroFuncionarioRequest,
  ): Promise<GetRelatorioCadastroFuncionarioResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/funcionarios/cadastro`, request);
      const response = handleAxiosResponse<GetRelatorioCadastroFuncionarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getRelatorioCargos(
    request: GetRelatorioCargosRequest,
  ): Promise<GetRelatorioCadastroFuncionarioResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/cargos`, request);
      const response = handleAxiosResponse<GetRelatorioCadastroFuncionarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportFuncionarios(
    request: GetReportFuncionariosRequest,
  ): Promise<GetReportFuncionariosResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/funcionarios`, request);
      const response = handleAxiosResponse<GetReportFuncionariosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportTreinamentos(
    request: GetReportTreinamentosRequest,
  ): Promise<GetReportTreinamentosResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/treinamentos`, request);
      const response = handleAxiosResponse<GetReportTreinamentosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportDocumentos(
    request: GetReportDocumentosRequest,
  ): Promise<GetReportDocumentosResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/documentos`, request);
      const response = handleAxiosResponse<GetReportDocumentosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportTreinamentoFuncionario(request: GetReportTreinamentoFuncionarioRequest): Promise<GetReportTreinamentoFuncionarioResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/treinamento-funcionario`, request);
      const response = handleAxiosResponse<GetReportTreinamentoFuncionarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getReportTreinamentoFuncionarioTerc(request: GetReportTreinamentoFuncionarioTercRequest): Promise<GetReportTreinamentoFuncionarioTercResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/treinamento-funcionario-terc`, request);
      const response = handleAxiosResponse<GetReportTreinamentoFuncionarioTercResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportFolhaPagamento(request: GetReportFolhaPagamentoRequest): Promise<GetReportFolhaPagamentoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/folha-pagamento`, request);
      const response = handleAxiosResponse<GetReportFolhaPagamentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportFolhaPagamentoDetalhada(request: GetReportFolhaPagamentoDetalhadaRequest): Promise<GetReportFolhaPagamentoDetalhadaResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/folha-pagamento-detalhada`, request);
      const response = handleAxiosResponse<GetReportFolhaPagamentoDetalhadaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportMapaConcretagem(request: GetReportMapaConcretagemRequest): Promise<GetReportMapaConcretagemResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/mapa-concretagem`, request);
      const response = handleAxiosResponse<GetReportMapaConcretagemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportPlanoQualidadeObra(request: GetReportPlanoQualidadeObraRequest): Promise<GetReportPlanoQualidadeObraResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/plano-qualidade-obra`, request);
      const response = handleAxiosResponse<GetReportPlanoQualidadeObraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportControleSustentabilidade(request: GetReportControleSustentabilidadeRequest): Promise<GetReportControleSustentabilidadeResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/controle-sustentabilidade`, request);
      const response = handleAxiosResponse<GetReportControleSustentabilidadeResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportMonitoramentoChecklist(request: GetReportMonitoramentoChecklistRequest): Promise<GetReportMonitoramentoChecklistResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/monitoramento-checklist`, request);
      const response = handleAxiosResponse<GetReportMonitoramentoChecklistResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportObraChecklist(request: GetReportObraChecklistRequest): Promise<GetReportObraChecklistResponse> {
    try {
      const result = await axiosReportInstance({}).post<GetReportObraChecklistResponse>(`/obra-checklist`, request);
      const response = result.status === 202
        ? result.data
        : handleAxiosResponse<GetReportObraChecklistResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportChecklistArea(request: GetReportChecklistAreaRequest): Promise<GetReportChecklistAreaResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/checklist-area`, request);
      const response = handleAxiosResponse<GetReportChecklistAreaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportChecklistEntregaLista(request: GetReportChecklistEntregaListaRequest): Promise<GetReportChecklistEntregaListaResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/checklist-entrega-lista`, request);
      const response = handleAxiosResponse<GetReportChecklistEntregaListaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getReportPlanoAuditoria(
    request: GetReportPlanoAuditoriaRequest
  ): Promise<GetReportPlanoAuditoriaResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/auditoria/planoAuditoria`, request);
      const response = handleAxiosResponse<GetReportPlanoAuditoriaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getReportListaChecklistServico(request: GetReportListaChecklistServicoRequest): Promise<GetReportListaChecklistServicoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/checklist-servicos`, request);
      const response = handleAxiosResponse<GetReportListaChecklistServicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#region  Qualidade
  async getReportAcoesPreventivas(
    request: GetReportAcoesPreventivasRequest
  ): Promise<GetReportAcoesPreventivasResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/qualidade/acoesPreventivas`, request);
      const response = handleAxiosResponse<GetReportAcoesPreventivasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getReportAcoesCorretivas(
    request: GetReportAcoesCorretivasRequest
  ): Promise<GetReportAcoesCorretivasResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/qualidade/acoesCorretivas`, request);
      const response = handleAxiosResponse<GetReportAcoesCorretivasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getReportProcessosRiscos(
    request: GetReportProcessosRiscosRequest
  ): Promise<GetReportProcessosRiscosResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/qualidade/processosRiscos`, request);
      const response = handleAxiosResponse<GetReportProcessosRiscosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportCronograma(
    request: GetReportCronogramaRequest
  ): Promise<GetReportCronogramaResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/qualidade/cronograma`, request);
      const response = handleAxiosResponse<GetReportCronogramaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportProvisaoRecursos(
    request: GetReportProvisaoRecursosRequest
  ): Promise<GetReportProvisaoRecursosResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/qualidade/provisaoRecursos`, request);
      const response = handleAxiosResponse<GetReportProvisaoRecursosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion
  async getReportListaChecklistServicoItem(request: GetReportListaChecklistServicoItemRequest): Promise<GetReportListaChecklistServicoItemResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/checklist-servicos/item`, request);
      const response = handleAxiosResponse<GetReportListaChecklistServicoItemResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportListaFornecedor(request: GetReportListaFornecedorRequest): Promise<GetReportListaFornecedorResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/fornecedores/lista`, request);
      const response = handleAxiosResponse<GetReportListaFornecedorResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getReportServicoProduto(request: GetReportServicoProdutoRequest): Promise<GetReportServicoProdutoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/servicos-produtos`, request);
      const response = handleAxiosResponse<GetReportServicoProdutoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportRequisicaoCompra(
    request: GetReportRequisicaoCompraRequest
  ): Promise<GetReportRequisicaoCompraResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/requisicoes-compras`, request);
      const response = handleAxiosResponse<GetReportRequisicaoCompraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportColetaPreco(request: GetReportColetaPrecoRequest): Promise<GetReportColetaPrecoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/coletas-precos`, request);
      const response = handleAxiosResponse<GetReportColetaPrecoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportOrdemCompra(request: GetReportOrdemCompraRequest): Promise<GetReportOrdemCompraResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/ordem-compra`, request);
      const response = handleAxiosResponse<GetReportOrdemCompraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#region Comercial Reports


  async getReportNovosNegociosLista(request: GetReportNovosNegociosListaRequest): Promise<GetReportNovosNegociosListaResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/novos-negocios-lista`, request);
      const response = handleAxiosResponse<GetReportNovosNegociosListaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportOrdemCompras(request: GetReportOrdemComprasRequest): Promise<GetReportOrdemComprasResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/ordem-compras`, request);
      const response = handleAxiosResponse<GetReportOrdemComprasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getReportNovosNegocios(request: GetReportNovosNegociosRequest): Promise<GetReportNovosNegociosResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/novos-negocios`, request);
      const response = handleAxiosResponse<GetReportNovosNegociosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportOrdemComprasLote(request: GetReportOrdemComprasLoteRequest): Promise<GetReportOrdemComprasLoteResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/ordem-compras-lote`, request);
      const response = handleAxiosResponse<GetReportOrdemComprasLoteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportGedInterno(request: GetReportGedInternoRequest): Promise<GetReportGedInternoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/ged/internos`, request);
      const response = handleAxiosResponse<GetReportGedInternoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportGedExterno(request: GetReportGedExternoRequest): Promise<GetReportGedExternoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/ged/externos`, request);
      const response = handleAxiosResponse<GetReportGedExternoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region Financeiro Reports

  async getReportContaPagar(request: GetReportContaPagarRequest): Promise<GetReportResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/contapagar`, request);
      const response = handleAxiosResponse<GetReportResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getReportContaReceber(request: GetReportContaReceberRequest): Promise<GetReportContaReceberResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/contareceber`, request);
      const response = handleAxiosResponse<GetReportContaReceberResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getReportContasPagarAnalitico(request: GetReportContasPagarAnaliticoRequest): Promise<GetReportContasPagarAnaliticoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/contaspagar/analitico`, request);
      const response = handleAxiosResponse<GetReportContasPagarAnaliticoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportContasReceberAnalitico(request: GetReportContasReceberAnaliticoRequest): Promise<GetReportContasReceberAnaliticoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/contasreceber/analitico`, request);
      const response = handleAxiosResponse<GetReportContasReceberAnaliticoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportContratoFinanceiroLista(request: GetReportContratoFinanceiroListaRequest): Promise<GetReportContratoFinanceiroListaResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/contratofinanceiro`, request);
      const response = handleAxiosResponse<GetReportContratoFinanceiroListaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportContratoFinanceiroIndividual(request: GetReportContratoFinanceiroIndividualRequest): Promise<GetReportContratoFinanceiroIndividualResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/contrato-financeiro-individual`, request);
      const response = handleAxiosResponse<GetReportContratoFinanceiroIndividualResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportSaldoBancarioLista(request: GetReportSaldoBancarioRequest): Promise<GetReportSaldoBancarioResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/saldobancario`, request);
      const response = handleAxiosResponse<GetReportSaldoBancarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportFluxoCaixaLista(request: GetReportFluxoCaixaListaRequest): Promise<GetReportFluxoCaixaListaResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/fluxocaixa`, request);
      const response = handleAxiosResponse<GetReportFluxoCaixaListaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportRateioGeralLista(request: GetReportRateioGeralRequest): Promise<GetReportRateioGeralResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/rateiogeral`, request);
      const response = handleAxiosResponse<GetReportRateioGeralResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion


  //#region Administração Reports

  async getReportPermissaoAcesso(request: GetReportPermissaoAcessoRequest): Promise<GetReportPermissaoAcessoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/permissao-acesso`, request.requiredMimeType);
      const response = handleAxiosResponse<GetReportPermissaoAcessoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportLogAcessoSistema(request: GetReportLogAcessoSistemaRequest): Promise<GetReportLogAcessoSistemaResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/log-acesso-sistema`, request);
      const response = handleAxiosResponse<GetReportLogAcessoSistemaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  //#endregion

  async getReportSatisfacaoClientePesquisa(
    request: GetReportSatisfacaoClientePesquisaRequest,
  ): Promise<GetReportSatisfacaoClientePesquisaResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/satisfacao-cliente-pesquisas`, request);
      const response = handleAxiosResponse<GetReportSatisfacaoClientePesquisaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#region DiarioObra
  async getReportDiarioObraIndividual(
    request: GetReportDiarioObraIndividualRequest,
  ): Promise<GetReportDiarioObraIndividualResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/diarioObraIndividual`, request);
      const response = handleAxiosResponse<GetReportDiarioObraIndividualResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region Tercerizacao
  async getReportListaFuncionariosT(
    request: GetReportListaFuncionariosTRequest,
  ): Promise<GetReportListaFuncionariosTResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/listaFuncionariosTerceirizados`, request);
      const response = handleAxiosResponse<GetReportListaFuncionariosTResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportFuncionarioTreinamentoTerc(
    request: GetReportFuncionarioTreinamentoTercRequest,
  ): Promise<GetReportFuncionarioTreinamentoTercResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/funcionarioTreinamentoTerc`, request);
      const response = handleAxiosResponse<GetReportFuncionarioTreinamentoTercResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportMedicaoTerceirizacao(
    request: GetReportMedicaoTerceirizacaoRequest,
  ): Promise<GetReportMedicaoTerceirizacaoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/medicaoTerceirizacao`, request);
      const response = handleAxiosResponse<GetReportMedicaoTerceirizacaoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportAssistenciaTecnica(
    request: GetReportAssistenciaTecnicaRequest,
  ): Promise<GetReportAssistenciaTecnicaResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/assistencia-tecnica`, request);
      const response = handleAxiosResponse<GetReportAssistenciaTecnicaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportAssistenciaTecnicaBasico(
    request: GetReportAssistenciaTecnicaBasicoRequest,
  ): Promise<GetReportAssistenciaTecnicaBasicoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/assistencia-tecnica/basico`, request);
      const response = handleAxiosResponse<GetReportAssistenciaTecnicaBasicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportAssistenciaTecnicaCompleto(
    request: GetReportAssistenciaTecnicaCompletoRequest,
  ): Promise<GetReportAssistenciaTecnicaCompletoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/assistencia-tecnica/completo`, request);
      const response = handleAxiosResponse<GetReportAssistenciaTecnicaBasicoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion



  //#region ENTREGA OBRA CLIENTE

  async getReportEntregaObraClienteSimples(
    request: GetReportEntregaObraClienteSimplesRequest,
  ): Promise<GetReportEntregaObraClienteSimplesResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/entrega-obras/simples`, request);
      const response = handleAxiosResponse<GetReportEntregaObraClienteSimplesResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportEntregaObraClienteFotografico1(
    request: GetReportEntregaObraClienteFotograficoRequest,
  ): Promise<GetReportEntregaObraClienteFotograficoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/entrega-obras/fotografico1`, request);
      const response = handleAxiosResponse<GetReportEntregaObraClienteFotograficoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportEntregaObraClienteFotografico2(
    request: GetReportEntregaObraClienteFotograficoRequest,
  ): Promise<GetReportEntregaObraClienteFotograficoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/entrega-obras/fotografico2`, request);
      const response = handleAxiosResponse<GetReportEntregaObraClienteFotograficoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportEntregaObraClienteGeral(
    request: GetReportEntregaObraClienteGeralRequest,
  ): Promise<GetReportEntregaObraClienteGeralResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/entrega-obras/geral`, request);
      const response = handleAxiosResponse<GetReportEntregaObraClienteGeralResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportEntregaObraClienteLote(
    request: GetReportEntregaObraClienteLoteRequest,
  ): Promise<GetReportEntregaObraClienteLoteResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/entrega-obras/lote`, request);
      const response = handleAxiosResponse<GetReportEntregaObraClienteLoteResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportEntregaObraClienteTermo(
    request: GetReportEntregaObraClienteTermoRequest,
  ): Promise<GetReportEntregaObraClienteTermoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/entrega-obras/termos`, request);
      const response = handleAxiosResponse<GetReportEntregaObraClienteTermoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion
  //#region Controle Estoque
  async getReportEntradaProduto(
    request: GetReportEntradaProdutoRequest,
  ): Promise<GetReportEntradaProdutoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/listaEntradaProdutos`, request);
      const response = handleAxiosResponse<GetReportEntradaProdutoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getReportSaidaProduto(
    request: GetReportSaidaProdutoRequest,
  ): Promise<GetReportSaidaProdutoResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/listaSaidaProdutos`, request);
      const response = handleAxiosResponse<GetReportSaidaProdutoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getReportControleEstoque(
    request: GetReportControleEstoqueRequest,
  ): Promise<GetReportControleEstoqueResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/listaControleEstoque`, request);
      const response = handleAxiosResponse<GetReportControleEstoqueResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  async getReportMaquinasEquip(request: GetReportMaquinasEquipRequest): Promise<GetReportMaquinasEquipResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/maquinas-equip`, request);
      const response = handleAxiosResponse<GetReportMaquinasEquipResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportMateriaisControlados(request: GetReportMateriaisControladosRequest): Promise<GetReportMateriaisControladosResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/materiais-controlados`, request);
      const response = handleAxiosResponse<GetReportMateriaisControladosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportTreinamentosFuncionarios(request: GetReportTreinamentosFuncionariosRequest): Promise<GetReportTreinamentosFuncionariosResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/lista-treinamentos-funcionarios`, request);
      const response = handleAxiosResponse<GetReportTreinamentosFuncionariosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getReportListaDisciplinas(request: GetReportListaDisciplinasRequest): Promise<GetReportListaDisciplinasResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/projetos/listaDisciplinas`, request);
      const response = handleAxiosResponse<GetReportListaDisciplinasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportPlanoProjeto(request: GetReportPlanoProjetoRequest): Promise<GetReportPlanoProjetoResponse> {
    try {
      console.log("request", request);
      const result = await axiosReportInstance({}).post(`/projetos/plano`, request);
      const response = handleAxiosResponse<GetReportPlanoProjetoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportObraServicosControlados(
    request: GetReportObraServicosControladosRequest,
  ): Promise<GetReportObraServicosControladosResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/obras/servicos-controlados`, request);
      const response = handleAxiosResponse<GetReportObraServicosControladosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportComprasRelatorioCompras(
    request: GetReportComprasRelatorioComprasRequest,
  ): Promise<GetReportComprasRelatorioComprasResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/compras/relatorio-compras`, request);
      const response = handleAxiosResponse<GetReportComprasRelatorioComprasResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getReportIndicadores(
    request: GetReportIndicadoresRequest,
  ): Promise<GetReportIndicadoresResponse> {
    try {
      const result = await axiosReportInstance({}).post(`/qualidade/indicadores`, request);
      const response = handleAxiosResponse<GetReportIndicadoresResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getReportFvsDinamico(
    request: GetReportFvsDinamicoRequest,
  ): Promise<GetReportFvsDinamicoResponse> {
    try {
      const result = await axiosReportInstance({}).post<GetMonitoramentoChecklistIAResponse>(
        "/monitoramento-checklist-ia", request
      );
      const response = handleAxiosResponse<GetMonitoramentoChecklistIAResponse>(result);
      const status = response.status ?? response.Status;
      const data = response.data ?? response.Data;

      if (status !== "ok" || !data || typeof data !== "object" || Array.isArray(data)) {
        throw new Error(response.message ?? response.Message ?? "Falha ao consultar o monitoramento da obra.");
      }

      const responseHtml = await axiosInstance({}).post<string>(
        "/relatorios/baixar-pdf-fvs", data, {
          responseType: "text",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (responseHtml.status !== 200 || typeof responseHtml.data !== "string" || !responseHtml.data.trim()) {
        throw new Error("Não foi possível gerar o relatório FVS. Tente novamente.");
      }

      return responseHtml.data;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
}
